import { render, staticRenderFns } from "./OnTheGoCheckout.vue?vue&type=template&id=5d47215c&scoped=true&"
import script from "./OnTheGoCheckout.vue?vue&type=script&lang=js&"
export * from "./OnTheGoCheckout.vue?vue&type=script&lang=js&"
import style0 from "./OnTheGoCheckout.vue?vue&type=style&index=0&id=5d47215c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47215c",
  null
  
)

export default component.exports